module.exports = __webpack_public_path__ + "static/media/logo-synapse52x50.ad348d79.svg";